export const showLoading = () => {
  const loadingCom = document.getElementById('loading-modal')
  if (loadingCom && !loadingCom.className.includes('visible')) {
    loadingCom.classList.add('visible')
  }
}

export const hideLoading = () => {
  const loadingCom = document.getElementById('loading-modal')
  if (loadingCom && loadingCom.className.includes('visible')) {
    loadingCom.classList.remove('visible')
  }
}
